import type { ViewType } from 'owa-calendar-actions';
import { getBirthdayEditButton } from 'owa-calendar-forms-common/lib/utils/command-bar/getBirthdayEditButton';
import { getDeleteButton } from 'owa-calendar-forms-common/lib/utils/command-bar/getDeleteButton';
import { closeItemPeek } from 'owa-calendar-peek';
import type { CalendarEvent } from 'owa-calendar-types';
import { editBirthdayEventMenuAction } from 'owa-event-context-menu';
import type { FilterableMenuItem } from 'owa-filterable-menu';
import type EventScope from 'owa-service/lib/contract/EventScope';

export default function getBirthdayPeekCommandBarItems(
    event: CalendarEvent,
    actionSource: ViewType,
    onDeleteClicked: (eventScope: EventScope) => void
): FilterableMenuItem[] {
    return [
        getBirthdayEditButton(event, editAction),
        getDeleteButton(
            event,
            actionSource,
            false /*isFullForm*/,
            false /*isInPopOutWindow*/,
            onDeleteClicked
        ),
    ];
}

export const editAction = (event: CalendarEvent) => {
    editBirthdayEventMenuAction(event);
    closeItemPeek();
};
